/**
 * Financials Screen Styles
 * 
 * Extracted to keep screen file under 300 lines per cursor rules.
 * Uses design tokens exclusively.
 */

import { StyleSheet } from 'react-native';
import { color, space, text, radius } from '../../../../shared/tokens/mobile';

export const financialsStyles = StyleSheet.create({
  scroll: { flex: 1 },
  scrollContent: { padding: space.md },

  // Results card
  resultsCard: { backgroundColor: color.primary, borderRadius: radius.lg, padding: space.lg, marginBottom: space.md, alignItems: 'center' },
  resultsTitle: { fontSize: text.caption.fontSize, color: color.surface, opacity: 0.8 },
  resultsAmount: { fontSize: 36, fontWeight: '700', color: color.surface, marginVertical: space.sm },
  resultsBreakdown: { width: '100%', marginTop: space.sm },
  resultRow: { flexDirection: 'row', justifyContent: 'space-between', paddingVertical: space.xs },
  resultLabel: { fontSize: text.caption.fontSize, color: color.surface, opacity: 0.7 },
  resultValue: { fontSize: text.caption.fontSize, color: color.surface },

  // Summary card
  summaryCard: { backgroundColor: color.backgroundSecondary, borderRadius: radius.lg, padding: space.md, marginBottom: space.md },
  sectionTitle: { fontSize: text.bodyMedium.fontSize, fontWeight: text.bodyMedium.fontWeight, color: color.textPrimary, marginBottom: space.sm },
  summaryRow: { flexDirection: 'row', justifyContent: 'space-between', paddingVertical: space.xs },
  summaryLabel: { fontSize: text.body.fontSize, color: color.textMuted },
  summaryValue: { fontSize: text.body.fontSize, color: color.textPrimary, fontWeight: text.bodyMedium.fontWeight },
  summaryValueHighlight: { color: color.warning },

  // Inputs card
  inputsCard: { backgroundColor: color.surface, borderRadius: radius.lg, padding: space.md, marginBottom: space.md, borderWidth: 1, borderColor: color.divider },
  inputGroup: { marginBottom: space.md },
  inputLabel: { fontSize: text.caption.fontSize, color: color.textMuted, marginBottom: space.xs },
  inputWrapper: { flexDirection: 'row', alignItems: 'center', backgroundColor: color.backgroundSecondary, borderRadius: radius.md, paddingHorizontal: space.sm },
  inputPrefix: { fontSize: text.body.fontSize, color: color.textMuted, marginRight: space.xs },
  input: { flex: 1, fontSize: text.body.fontSize, color: color.textPrimary, paddingVertical: space.sm },
  inputSuffix: { fontSize: text.body.fontSize, color: color.textMuted, marginLeft: space.xs },

  // Term buttons
  termRow: { marginBottom: space.md },
  termButtons: { flexDirection: 'row', gap: space.sm, marginTop: space.xs },
  termButton: { flex: 1, paddingVertical: space.sm, backgroundColor: color.backgroundSecondary, borderRadius: radius.md, alignItems: 'center' },
  termButtonActive: { backgroundColor: color.primary },
  termButtonText: { fontSize: text.caption.fontSize, color: color.textMuted },
  termButtonTextActive: { color: color.surface, fontWeight: text.bodyMedium.fontWeight },
  customTermRow: { flexDirection: 'row', alignItems: 'center', marginTop: space.sm, gap: space.sm },
  customTermLabel: { fontSize: text.caption.fontSize, color: color.textMuted },
  customTermInput: { flex: 1, backgroundColor: color.backgroundSecondary, borderRadius: radius.md, paddingHorizontal: space.sm, paddingVertical: space.xs, fontSize: text.body.fontSize, color: color.textPrimary, maxWidth: 80 },

  // Metrics card
  metricsCard: { backgroundColor: color.backgroundSecondary, borderRadius: radius.lg, padding: space.md },
  metricsGrid: { flexDirection: 'row', flexWrap: 'wrap', gap: space.sm },
  metricBox: { width: '48%', backgroundColor: color.surface, borderRadius: radius.md, padding: space.sm, alignItems: 'center' },
  metricValue: { fontSize: text.cardTitle.fontSize, fontWeight: text.cardTitle.fontWeight, color: color.textPrimary, marginTop: space.xs },
  metricLabel: { fontSize: text.caption.fontSize, color: color.textMuted },
  metricHint: { fontSize: 10, color: color.textMuted, marginTop: 2 },
});

